var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLSignOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconL-sign-out",
    x: 0.197,
    y: 0.883,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "ph-sign-out-light"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.028,13.289l-4.02,4.02c-0.104,0.104 -0.247,0.168 -0.406,0.168c-0.317,0 -0.574,-0.257 -0.574,-0.574c-0,-0.158 0.064,-0.302 0.168,-0.406l3.04,-3.04l-9.338,0c-0.317,0 -0.575,-0.257 -0.575,-0.574c0,-0.318 0.258,-0.575 0.575,-0.575l9.338,0l-3.04,-3.04c-0.105,-0.104 -0.169,-0.248 -0.169,-0.406c-0,-0.318 0.257,-0.575 0.574,-0.575c0.159,0 0.303,0.065 0.407,0.169l4.02,4.021c0.104,0.104 0.169,0.247 0.169,0.406c-0,0.158 -0.065,0.302 -0.169,0.406Zm-9.599,7.444l-6.892,-0c-0.106,-0.001 -0.191,-0.086 -0.192,-0.192l0,-15.317c0.001,-0.105 0.086,-0.191 0.192,-0.191l6.892,-0c0.318,-0 0.575,-0.257 0.575,-0.575c-0,-0.317 -0.257,-0.574 -0.575,-0.574l-6.892,0c-0.74,0.001 -1.339,0.6 -1.34,1.34l-0,15.317c0.001,0.74 0.6,1.339 1.34,1.34l6.892,0c0.318,0 0.575,-0.257 0.575,-0.574c-0,-0.317 -0.257,-0.574 -0.575,-0.574Z",
    style: {
      fillRule: "nonzero"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLSignOut);
export default __webpack_public_path__ + "static/media/iconL-sign-out.096cdb6c4c99a6d6e6e8f14c9a86a6da.svg";
export { ForwardRef as ReactComponent };